/* @flow */
import { chatMessageTypes, ChatMessage, ChatGapMessage } from 'entities/ChatMessage';
import Collection from 'lib/Collection';

class ChatMessages extends Collection {
  initialize() {
    this.model = (attrs: Object, options: Object) => {
      const ChatMessageType = chatMessageTypes[attrs.type] || ChatMessage;
      return new ChatMessageType(attrs, options);
    };
    this.comparator = 'seq';
  }

  static yieldMessagesForGap(gap: ChatGapMessage): Promise<ChatMessages> {
    const chatId = gap.getChatId();
    return ChatMessages.yieldMessagesForChatId(chatId, { data: gap.getParams() });
  }

  static yieldMessagesForChatId(chatId: string, options: Object = {}): Promise<ChatMessages> {
    const messages = new ChatMessages();
    messages.url = `/chats/${chatId}/messages`;
    return messages.fetch(options);
  }
}

export default ChatMessages;



// WEBPACK FOOTER //
// ./src/collections/ChatMessages.js